import { Column, Row } from 'components/v2/Grid'
import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { NextImage } from 'components/v2/NextImage'
import { SingleDatePicker } from 'react-dates'
import { ThinChevron } from 'components/v2/Icons'
import moment from 'moment'
import styled from 'styled-components'
import { updateFilter } from 'redux/modules/filters'
import { CalendarBlank } from 'phosphor-react'

const ResultsController = () => {
  const dispatch = useDispatch()
  const [focus, setFocus] = useState(false)
  const { filters } = useSelector(state => ({
    filters: state.filters
  }))

  const onDateChange = date => {
    dispatch(
      updateFilter({
        startDate: moment(date).format('YYYY-MM-DD'),
        endDate: moment(date)
          .add(4, 'days')
          .format('YYYY-MM-DD')
      })
    ),
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
  }

  return (
    <Container as='section' bg='#f8f8f8'>
      <DateContainer onClick={() => setFocus(!focus)} className='filter-field' id='date-filter'>
        <DatePicker cy_id='input-date' className='date-picker'>
          <CalendarBlank size={20} color='#FF7708' weight='bold' />
          <Column pl='3px' ml='10px'>
            <ContentDate>
              <SingleDatePicker
                readOnly
                date={moment(filters?.startDate)}
                onDateChange={onDateChange}
                focused={focus}
                onFocusChange={() => setFocus(!focus)}
                noBorder={true}
                displayFormat='[A partir de:] DD/MM/Y'
                id='startDate'
                numberOfMonths={1}
                hideKeyboardShortcutsPanel
              />
            </ContentDate>
          </Column>
        </DatePicker>
        <ImageIndex>
          <ThinChevron height='16px' variant={!focus ? 'top' : 'down'} />
        </ImageIndex>
      </DateContainer>
    </Container>
  )
}

const Container = styled(Row)`
  justify-content: flex-end;
  min-width: 1120px;
  padding: 28px 0 20px 0;
  @media (max-width: 992px) {
    min-width: 100%;
    flex-direction: column;
    justify-content: space-between;
  }
`

const DateContainer = styled(Row)`
  margin-left: 10px;
  cursor: pointer;
  align-items: center;
  background: white;
  border: 0.5px solid #bdc3c7;
  border-radius: 4px;
  height: 51px;
  max-width: 325px;
  width: 100%;
  @media (max-width: 992px) {
    margin-left: 0px;
    max-width: 398px;
    width: 100%;
  }
`
const ImageIndex = styled.div`
  margin-right: 15px;
  z-index: 2;
`
const DatePicker = styled.div`
  display: flex;
  box-shadow: 0;
  border: 0;
`
const ContentDate = styled.div`
  #startDate {
    width: 100%;
  }
  .DateInput {
    width: 100%;
  }
  .DateInput_input {
    cursor: pointer !important;
    font-size: 14px !important;
    font-weight: 400;
    font-family: Sora, sans-serif;
  }
  .DateInput_fangStroke {
    display: none;
  }
  .SingleDatePicker,
  .SingleDatePickerInput_1 {
    width: 100%;
  }
  .SingleDatePicker_picker {
    top: 39px !important;
    left: -38px !important;

    @media (max-width: 425px) {
      left: -8px !important;
    }

    @media (max-width: 375px) {
      left: -30px !important;
    }

    @media (max-width: 320px) {
      left: -50px !important;
    }
  }
  .DayPicker {
    width: 313px !important;
    @media (max-width: 320px) {
      width: 300px !important;
    }
  }
  .DayPicker_transitionContainer {
    width: 313px !important;
    @media (max-width: 320px) {
      width: 300px !important;
    }
  }
  .CalendarMonthGrid {
    @media (max-width: 320px) {
      left: 0px !important;
    }
  }
  .DayPicker_weekHeader {
    @media (max-width: 320px) {
      left: -8px !important;
    }
  }
  .DayPicker_focusRegion {
    @media (max-width: 320px) {
      width: 300px !important;
    }
  }
`

export default ResultsController
